import { render, staticRenderFns } from "./NeiBuGongShi7.vue?vue&type=template&id=2b0e87d4&scoped=true&"
import script from "./NeiBuGongShi7.vue?vue&type=script&lang=js&"
export * from "./NeiBuGongShi7.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuGongShi7.vue?vue&type=style&index=0&id=2b0e87d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e87d4",
  null
  
)

export default component.exports